import { createFileRoute, redirect } from "@tanstack/react-router";
import { HOME_PATH, landingFor } from "../navigation.ts";

/**
 * Where a new session lands — a decision, not a page.
 *
 * Signing in used to go straight to `/dashboard`, which asks which of *your*
 * businesses you want to work on. For a moderator or an administrator that is
 * the wrong question: they signed in to review other people's, and they were
 * met by an empty list telling them to register one.
 *
 * The rule lives on a route rather than in the sign-in form because a session
 * starts in more than one way. The password form navigates here; an OAuth
 * provider redirects here through `callbackURL`. Both then get the same answer,
 * and a future third route into a session gets it for free.
 *
 * `replace`, always: this URL is a hop, and the back button must go to wherever
 * somebody was before they signed in, not bounce them through it again.
 */
export const Route = createFileRoute("/signed-in")({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(
			context.trpc.session.queryOptions(),
		);

		// Reachable signed-out by a stale bookmark, or an OAuth attempt that failed
		// on the way back. Home is honest about what happened; a sign-in form
		// looping through here would not be.
		if (session.user === null) {
			throw redirect({ to: HOME_PATH, replace: true });
		}

		throw redirect({ to: landingFor(session.permissions), replace: true });
	},
});
